<!--
Author:
Create Time: 2019-07-29 10:20:27
Description:
-->
<template>
  <div class="com-attachments-edit">
    <accessoryList ref="fileLinkmanList" :belongtoProjectId="form.id" @update:addFileList="getAddFileList" :belongtoProjectName="form.typeName"/>
  </div>
</template>

<script>
import accessoryList from "../../module/system/sysPropertyRightManager/tabs/accessoryList";

export default {
  name: "attachmentsEdit",
  props: ["form"],
  components: {
    accessoryList
  },
  data() {
    return {};
  },
  methods: {
    uploadOpen() {
      this.docTypeForm.docType = "";
      this.fileList = [];
      this.isUploadDialogVisible = true;
    },
    //上传完附件调用的方法，赋值给页面存储的附件列表
    getAddFileList(result) {
      this.form.accessoryInfoList = result;
    },
    getData(businessId) {
      return this.$refs.fileLinkmanList.getData(businessId);
    },
    handleThisTabClick() {
      if (!this.form.id) {
        //根据业务id初始化附件列表数据
        this.getData("-111111112");
      } else {
        this.getData(this.form.id);
      }
    }
  }
};
</script>

<style scoped lang="less">
// .com-attachments-edit {}
</style>



// WEBPACK FOOTER //
// src/components/accessory/attachmentsEdit.vue